import React from 'react';
import ActionBarStrip from '../../_partials/ActionBarStrip';
import CentralColumn from '../../../DeviationPage/_partials/CentralColumn';
import { useDeviationAttributes } from '../../../DeviationViews/hooks/useDeviationAttributes';
import CommentButton from '../../buttons/CommentButton';
import OrderCommissionButton from '../../buttons/OrderCommissionButton';
import CommissionStatusButton from '../../buttons/CommissionStatusButton';
import EditButton from '../../buttons/EditButton';
import DeleteButton from '../../buttons/DeleteButton';
import MoreButton from '../../buttons/MoreButton';
import CommissionPointsAndPrice from '../../../CommissionPointsAndPrice';
import { formatDollars } from '../../../utils/formatting';
import s from './CommissionActionBar.scss';
const CommissionActionBar = ({ isOwner, deviation: { commission }, deviation })=>{
    const { hasMoreActions, isCommentable, isEditable, isDeletable, isAuthorCommissionable } = useDeviationAttributes(deviation, isOwner);
    if (!commission) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(ActionBarStrip, null, /*#__PURE__*/ React.createElement(CentralColumn, {
        className: s['bar-elements-wrapper']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['left-side']
    }, isCommentable && /*#__PURE__*/ React.createElement("span", {
        className: s['icon']
    }, /*#__PURE__*/ React.createElement(CommentButton, {
        deviation: deviation,
        isOwner: isOwner
    }))), /*#__PURE__*/ React.createElement("div", {
        className: s['right-side']
    }, (isOwner || commission.isActive) && isAuthorCommissionable && /*#__PURE__*/ React.createElement("span", {
        className: s['icon']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['price']
    }, /*#__PURE__*/ React.createElement(CommissionPointsAndPrice, {
        points: commission.pointsCost,
        price: formatDollars(commission.dollarsCost)
    }))), !isOwner && isAuthorCommissionable && /*#__PURE__*/ React.createElement("span", {
        className: s['icon']
    }, /*#__PURE__*/ React.createElement(OrderCommissionButton, {
        deviation: deviation
    })), isEditable && /*#__PURE__*/ React.createElement("span", {
        className: s['icon']
    }, /*#__PURE__*/ React.createElement(CommissionStatusButton, {
        deviation: deviation
    })), isDeletable && /*#__PURE__*/ React.createElement("span", {
        className: s['icon']
    }, /*#__PURE__*/ React.createElement(DeleteButton, {
        deviation: deviation
    })), isEditable && /*#__PURE__*/ React.createElement("span", {
        className: s['icon']
    }, /*#__PURE__*/ React.createElement(EditButton, {
        deviation: deviation
    })), hasMoreActions && /*#__PURE__*/ React.createElement("span", {
        className: s['icon']
    }, /*#__PURE__*/ React.createElement(MoreButton, {
        deviation: deviation
    })))));
};
CommissionActionBar.displayName = 'CommissionActionBar';
export default CommissionActionBar;

//# sourceMappingURL=CommissionActionBar.js.map